import React, { createContext, useContext, ReactNode, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { setNavigationCallback } from '../utils/api';

interface NavigationContextType {
  navigateToLogin: () => void;
  navigateToDashboard: () => void;
  navigateToHome: () => void;
}

const NavigationContext = createContext<NavigationContextType | undefined>(undefined);

export const useNavigation = () => {
  const context = useContext(NavigationContext);
  if (context === undefined) {
    throw new Error('useNavigation must be used within a NavigationProvider');
  }
  return context;
};

interface NavigationProviderProps {
  children: ReactNode;
}

export const NavigationProvider: React.FC<NavigationProviderProps> = ({ children }) => {
  const navigate = useNavigate();

  const navigateToLogin = () => {
    navigate('/login', { replace: true });
  };

  const navigateToDashboard = () => {
    navigate('/dashboard', { replace: true });
  };

  const navigateToHome = () => {
    navigate('/', { replace: true });
  };

  // Set the navigation callback for the API interceptor
  useEffect(() => {
    setNavigationCallback(navigateToLogin);
  }, []);

  const value = {
    navigateToLogin,
    navigateToDashboard,
    navigateToHome,
  };

  return (
    <NavigationContext.Provider value={value}>
      {children}
    </NavigationContext.Provider>
  );
};